import { render, staticRenderFns } from "./BoardLayout.vue?vue&type=template&id=657a9c7f&"
import script from "./BoardLayout.vue?vue&type=script&lang=js&"
export * from "./BoardLayout.vue?vue&type=script&lang=js&"
import style0 from "./BoardLayout.vue?vue&type=style&index=0&id=657a9c7f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports